class AnalyticsService {
  constructor() {
    this.initialized = false;
    this.provider = null;
    this.disabled = false;
    this.appName = '';
    this.debug = process.env.NODE_ENV !== 'production';
    this.gtagId = null;
    this.gtag = null;
  }

  init(options = {}) {
    this.appName = options.appName || 'Language Shadowing App';
    this.disabled = options.disabled || false;
    this.provider = options.provider || null;
    this.gtagId = options.gtagId || null;
    this.initialized = true;

    // vue-gtag hangs $gtag off Vue.prototype, so main.js passes the instance in.
    this.gtag = options.gtagInstance || null;

    if (this.debug) {
      console.log('Analytics service initialized:', {
        provider: this.provider ? 'gtag' : 'none',
        disabled: this.disabled,
        appName: this.appName,
        gtagId: this.gtagId
      });
    }

    return this;
  }

  trackEvent(action, params = {}) {
    if (!this.initialized) return;

    // Before the disabled check: dev has analytics disabled, this log is how it verifies events.
    if (this.debug) {
      console.log('Analytics trackEvent:', action, params);
    }

    if (this.disabled) return;

    if (this.gtag) {
      // Forward every param (top-level custom dimensions too); extraParams wins.
      const { category, label, value, extraParams, ...rest } = params;
      this.gtag.event(action, {
        'event_category': category || 'General',
        'event_label': label || '',
        'value': value !== undefined ? value : null,
        ...rest,
        ...extraParams
      });
    }
  }

  trackPageView(pagePath, pageTitle) {
    if (!this.initialized || this.disabled) return;

    if (this.debug) {
      console.log('Analytics trackPageView:', pagePath, pageTitle);
    }

    if (this.gtag) {
      this.gtag.config(this.gtagId, {
        page_path: pagePath,
        page_title: pageTitle
      });
    }
  }

  trackTiming(category, variable, time) {
    if (!this.initialized || this.disabled) return;

    if (this.debug) {
      console.log('Analytics trackTiming:', category, variable, time);
    }

    if (this.gtag) {
      this.gtag.event('timing_complete', {
        name: variable,
        value: time,
        event_category: category
      });
    }
  }
}

const analytics = new AnalyticsService();
export default analytics;
